import styled from '@emotion/styled'
import { css } from '@emotion/core'

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e3e5e8;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(7, 7, 15, 0.1);
  box-sizing: border-box;
`

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: stretch;
  min-width: 0;
`

export const SerialHeader = styled.div`
  color: rgba(0, 81, 196, 1);
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
`

export const SerialHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`

export const ModelDescription = styled.span`
  font-family: Arial, sans-serif;
  font-size: 10px;
  color: rgba(7, 7, 15, 0.4);
  line-height: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
  letter-spacing: 0.02em;
`

export const LeadBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  height: 15px;
  border-radius: 8px;
  background: rgba(7, 7, 15, 0.7);
  color: rgba(255, 255, 255, 1);
  font-family: Arial, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
`

export const CapacityRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
`

export const CapacityText = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: ${({ atLimit }) =>
    atLimit ? 'rgba(193, 39, 45, 1)' : 'rgba(7, 7, 15, 0.6)'};
`

export const SnapshotList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const SnapshotRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SnapshotRowSkeleton = styled.div`
  height: 20px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

export const SnapshotLabelGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const SnapshotLabel = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: rgba(7, 7, 15, 0.7);
  line-height: 16px;
`

export const ExpiryText = styled.span`
  font-family: Arial, sans-serif;
  font-size: 11px;
  line-height: 14px;
  color: ${({ level }) => {
    if (level === 'error') return 'rgba(193, 39, 45, 1)'
    if (level === 'warning') return 'rgba(193, 104, 14, 1)'
    return 'rgba(7, 7, 15, 0.4)'
  }};
`

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`

export const actionBtnCss = css`
  display: flex;
  height: 22px;
  padding: 5px 8px;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #8c96a2;
  background: #fff;
  cursor: pointer;
  font-family: Arial, sans-serif;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #0b2e6b;

  &:hover {
    border-color: rgba(30, 122, 255, 1);
    color: rgba(30, 122, 255, 1);
  }
`

export const iconBtnCss = css`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: #4f5764;

  &:hover:not(:disabled) {
    color: rgba(180, 4, 12, 1);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export const SnapshotSlotLabel = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: rgba(7, 7, 15, 0.7);
  line-height: 16px;
`

export const SnapshotSlotAvailable = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: rgba(7, 7, 15, 0.4);
  line-height: 16px;
`

export const DeletingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.82);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

export const CardErrorBanner = styled.div`
  padding: 6px 10px;
  border-radius: 3px;
  background: rgba(193, 39, 45, 0.08);
  border: 1px solid rgba(193, 39, 45, 0.3);
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: rgba(193, 39, 45, 1);
  line-height: 16px;
`

export const DeletingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid rgba(7, 7, 15, 0.12);
  border-top-color: #0b2e6b;
  border-radius: 50%;
  animation: deletingSpinAnim 0.75s linear infinite;
  @keyframes deletingSpinAnim {
    to {
      transform: rotate(360deg);
    }
  }
`
